
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/search-bar",
      function () {
        return require("private-next-pages/components/search-bar.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/search-bar"])
      });
    }
  